export default __webpack_public_path__ + "static/media/aquarium.7968e652.png";